import a from 'react';
import m from 'classnames';

var c="9a91ed332b717c49334ff67c826ddf3ec7852f1576027a0c86da9a0eaf4faae5",r=`._container_tclaz_1 {
	--dynamic-scenes-container__width: 360px;
	--dynamic-scenes-container__padding: 24px;
}

@media (min-width: 768px) {
	._container_tclaz_1 {
		width: var(--dynamic-scenes-container__width);
	}
}

._main_tclaz_12 {
	padding: var(--dynamic-scenes-container__padding);
	overflow: auto;
	max-height: 80vh;
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(c)){var e=document.createElement("style");e.id=c,e.textContent=r,document.head.appendChild(e);}})();var t={container:"_container_tclaz_1",main:"_main_tclaz_12"};function p({width:e,padding:i,header:d,children:s,...n}){let o=a.useMemo(()=>({...n.style,"--dynamic-scenes-container__width":e,"--dynamic-scenes-container__padding":i}),[n.style,e,i]);return a.createElement("div",{...n,style:o,className:m(t.container,n.className)},d,a.createElement("div",{className:t.main},s))}

export { p as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-QWEGO2DW.mjs.map